
(function(){



    window.ws.select = function(jquery_or_node){

        let item = $(jquery_or_node);
        if(!item.length){
            console.error("No item to select");
            return;
        }

        let dom_element = item.get(0);
        selectElementContents(dom_element);

    };


    //
    // Select dom element
    //
    // https://stackoverflow.com/questions/4183401/can-you-set-and-or-change-the-user-s-text-selection-in-javascript
    function selectElementContents(el) {
        var body = document.body, range, sel;
        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(el);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(el);
                sel.addRange(range);
            }
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(el);
            range.select();
        }
    }


})(); // End auto-executable anonymous function


